import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

import { useProgramsStore } from '@/stores/programs';
import { useUiStore } from '@/stores/ui';
import VLimitTag from './VLimitTag.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AnaliticsCellLimit',
  props: {
    report: null,
    groupReport: null,
    teamId: null
  },
  setup(__props: any) {

const props = __props as { report?: any, groupReport?: any, teamId: string }



const report = props.report || props.groupReport.find((item: any) => item.teamId === props.teamId)

const programsStore = useProgramsStore()
const uiStore = useUiStore()

const onClick = (e: MouseEvent) => {
  e.stopPropagation()
  const team = programsStore.teams.find(item => item.id === props.teamId)
  uiStore.team = team
  uiStore.teamReportsPage = "limits"
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!_unref(report))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createTextVNode("-")
        ], 64))
      : (_openBlock(), _createBlock(VLimitTag, {
          key: 1,
          report: _unref(report),
          style: {"display":"inline-flex"},
          onClick: onClick
        }, null, 8, ["report"]))
  ]))
}
}

})